/*                                                 *\
** ----------------------------------------------- **
**          Calliope - Pixos Game Engine   	       **
** ----------------------------------------------- **
**  Copyright (c) 2020-2022 - Kyle Derby MacInnis  **
**                                                 **
**    Any unauthorized distribution or transfer    **
**       of this work is strictly prohibited.      **
**                                                 **
**               All Rights Reserved.              **
** ----------------------------------------------- **
\*                                                 */

import { TilesetLoader } from "./TilesetLoader.jsx";
import { SpriteLoader } from "./SpriteLoader.jsx";
import { ObjectLoader } from "./ObjectLoader.jsx";
import { ActionLoader } from "./ActionLoader.jsx";
import { EventLoader } from "./EventLoader.jsx";
import { AudioLoader } from "./AudioLoader.jsx";
// Helps Loads New Tileset Instance
export default {
  TilesetLoader,
  SpriteLoader,
  ObjectLoader,
  ActionLoader,
  EventLoader,
  AudioLoader,
};
